module.exports = __webpack_public_path__ + "img/dongtai.16c51c54.jpg";